<template>

  <div  height="112px" :class="{'def-bg': !noBg}" v-if="!isPhone">
    <div class="h-warp def-content">
      <div class="h-icon"><span class="fz" data-boldtype="0" @click="navgtTo('/')">法天眼</span></div>
      <div class="h-menu">
        <div class="m-item" :class="{'active': selectIndex === 0}" @click="navgtTo('/')">首页</div>
        <div class="m-item" :class="{'active': selectIndex === 1}" @click="navgtTo('/test')">{{ isSupplier ? '企业产品' : '税务体检' }}</div>
        <div v-if="isSupplier" class="m-item" :class="{'active': selectIndex === 4}" @click="navgtTo('/testOrg')">律师/机构产品</div>
        <div class="m-item" :class="{'active': selectIndex === 2}" @click="openNewLink('https://apppiq67wgz6785.h5.xiaoeknow.com')">用工风控
          <el-badge value="HOT" class="hot-item" v-show="selectIndex === 2"></el-badge>
        </div>
        <div class="m-item" :class="{'active': selectIndex === 3}" @click="openNewLink('https://www.fadingwang.com/#/home')">劳动法AI
          <el-badge value="Free" class="hot-item" v-show="selectIndex === 3"></el-badge>
        </div>
        <div class="m-item" :class="{'active': selectIndex === 4}" @click="openNewLink('https://apppiq67wgz6785.h5.xiaoeknow.com/p/course/big_column/p_6437f7f0e4b0b2d1c407757e')">十大系统
          <el-badge value="Free" class="hot-item" v-show="selectIndex === 3"></el-badge>
        </div>
        <div class="m-item" :class="{'active': selectIndex === 5}" @click="openNewLink('http://www.fajiankeji.com')">用工体检
          <el-badge value="Free" class="hot-item" v-show="selectIndex === 3"></el-badge>
        </div>
      </div>
      <div class="h-right">
        <div class="hr-left">
          <slot v-if="selectIndex === 1 || selectIndex === 4">
            <el-input
              placeholder="请输入您要搜索的内容"
              suffix-icon="el-icon-search"
              v-model="fullSearch"
              clearable
              @keyup.enter.native="goSearch"
              maxlength="10"></el-input>
          </slot>
        </div>
        <div class="hr-right">
          <div style="width: 27px;height: 40px;"></div>
          <router-link to="/userInfo" title="个人中心" class="svg-icon-warp blk">
            <svg-icon icon-class="userCenter" class-name="userCenter-icon"/>
          </router-link>

          <div style="width: 27px;height: 40px;"></div>

          <el-dropdown @command="handleHeaderDropDown" v-loading.fullscreen.lock="fullscreenLoading" trigger="click">
            <a class="svg-icon-warp blk">
              <el-badge value="new" class="badge-item" v-show="hasNewMessage"></el-badge>
              <svg-icon icon-class="setting" class-name="login-icon"/>

            </a>
            <el-dropdown-menu slot="dropdown" style="min-width: 150px;">
              <el-dropdown-item command="login" v-if="!isLogined"><i class="el-icon-custom-denglu"></i>登录
              </el-dropdown-item>
              <el-dropdown-item command="myReport"><i class="el-icon-custom-baogao"></i> 我的报告</el-dropdown-item>

              <el-dropdown-item command="myMessage" v-if="isLogined">
                <i class="el-icon-news"></i>
                我的消息
                <el-badge :value="newMessageCount" :max="20" class="item" v-if="hasNewMessage">
                </el-badge>
              </el-dropdown-item>

              <el-dropdown-item command="loginOut" v-if="isLogined"><i class="el-icon-custom-tuichu"></i> 退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>
      </div>
    </div>
    <el-drawer
      title="站内消息"
      :visible.sync="messageDrawer"
      :direction="messageDirection"
      @opened="setMessageDivHeight">
      <div class="messageDiv" id="messageDiv" style="min-width: 400px;">
        <div style="width: 100%;position: relative;bottom: 1px;" align="center">
          <el-pagination
            background
            @current-change="handleMessagePageChange"
            @size-change="handleMessageSizeChange"
            :page-size="messageInfo.pageSize"
            layout="prev, pager, next"
            :total="messageInfo.total">
          </el-pagination>
        </div>
        <div style="width: 100%;height: 40px;position: relative;top: 20px; border-bottom: #00BCA1 1px solid;">
          <el-checkbox style="position: absolute;left: 10px;top:5px;" :indeterminate="isIndeterminate"
                       v-model="checkAllMessage" @change="handleCheckAllMessage">全选
          </el-checkbox>
          <el-dropdown @command="messageHandleCommand" style="margin-left: 30px;">
            <el-button type="primary" size="mini" plain :disabled="markedBtnActive"
                       :loading="markedBtnActive">
              标记为<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="markedHadRead">已读</el-dropdown-item>
              <el-dropdown-item command="markedDelete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" style="margin-left: 5px;" :disabled="markedBtnActive"
                     :loading="markedBtnActive" @click="allMessageIsRead()">
            全部已读<i class="el-icon-message"></i>
          </el-button>
          <el-button type="danger" size="mini" :disabled="markedBtnActive" :loading="markedBtnActive"
                     @click="allMessageDelete()">
            全部删除<i class="el-icon-delete"></i>
          </el-button>
        </div>
        <ul>
          <transition-group name="msglist" tag="ul">
            <li v-for="item in messageInfo.messageInfoData" :key="item.id">
              <div style="position: relative;width: 100%;height: 100%;">
                <div style="position: absolute;top: 40px; left: -20px;">
                  <el-checkbox :value="item.id" :label="item.id" v-model="item.isChecked"
                               @change="handleCheckedMessageChange(item)"></el-checkbox>
                </div>
                <div style="width: 100%;height: 100%;position: relative">
                  <div class="readTipIcon">
                    <i class="el-icon-custom-weidu isNotRead" v-if="item.isRead === 0"></i>
                    <i class="el-icon-custom-ryes isRead" v-if="item.isRead === 1"></i>
                  </div>
                  <div>
                    <el-card shadow="hover" style="height: 100px;" :class="{'isNotRead':item.isRead === 0}">
                    <span style="font-size: 19px;position: absolute;top: 18px;left: 30px;">
                      {{ item.messageTitle }}
                      <span @click="showMessageDetail(item)" class="titleShowDetail">点击查看详情</span>
                    </span>
                      <div class="messageDateDiv">日期：<span>{{ item.createDate }}</span></div>
                      <div class="messageContentDiv" v-html="item.messageContent"></div>
                    </el-card>
                  </div>
                </div>
              </div>
            </li>
          </transition-group>
        </ul>

      </div>
      <el-dialog
        :title="messageTitle"
        :visible.sync="messageVisible"
        width="30%"
        :append-to-body="true"
        :close-on-click-modal="false">
        <div>
          <span>发件人：</span>
          <span>{{ messageDetail.messageSender}}</span>
        </div>
        <div>
          <span>发送日期：</span>
          <span>{{ messageDetail.createDate}}</span>
        </div>
        <el-divider content-position="left">消息内容</el-divider>
        <div v-html="messageDetail.messageContent">

        </div>
        <div>

        </div>
      </el-dialog>
    </el-drawer>

  </div>
  <div style="width: 100%;background-color: #00BCA1;color: white;height: 60px;text-align: center;line-height: 60px;font-size: 25px;" v-else>
    法天眼
  </div>
</template>

<script>
  import {loginOut} from '@/api/userInfo/userLogin';
  import {getNettyMessage, updateMessageIsRead, deleteMessage} from '@/api/userInfo/userInfo'
  import {woleSearch} from '@/api/common';
  import {isPhone} from '@/components/utils/isPhone'
  export default {

    screenHeight: document.body.clientHeight,
    getMessage (data) {
    },
    computed: {
      isSupplier() {
          return this.$store.state.userInfo.isSupplier;
      },
    },
    name: "Header",
    data() {
      return {
        isPhone: false,

        fullSearch: '',
        fullscreenLoading: false,
        isLogined: false,
        hasNewMessage: false,
        newMessageCount: 0,
        messageDrawer: false,
        messageDirection: 'rtl',

        isIndeterminate: false,
        checkAllMessage: false,
        checkedMessage: [],

        markedBtnActive: false,

        messageInfo: {
          currentPage: 1,
          pageSize: 10,
          total: 10,
          messageInfoData: []
        },

        messageVisible: false,
        messageDetail: {},
        messageTitle: '',

        notifyPromise: Promise.resolve()
      };
    },
    props: {
      selectIndex: Number,
      noBg: Boolean,
    },
    mounted() {
      if (localStorage.getItem('userToken') && localStorage.getItem("userToken") !== 'null'
        && localStorage.getItem("userToken") !== 'undefined') {
        this.isLogined = true;
        this.getNettyMessage({
          page: this.messageInfo.currentPage,
          pageSize: this.messageInfo.pageSize
        });
        if (localStorage.getItem('initPassword') === '0') {
          if (localStorage.getItem('initPasswordCount') === '0') {
            this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(() => {
              this.$notify({
                title: '初始密码未更改',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                message: "<a class='linkA' href='/userInfo/userCenter?toTableIndex=2'>您的初始密码尚未更改,点击前往更改</a>",
                position: 'bottom-right',
                duration: 0,
                onClose: function () {
                  localStorage.setItem('initPasswordCount', '0');
                }
              });
            });
            localStorage.setItem('initPasswordCount', '1');
          }
        }

        if (localStorage.getItem('emailBind') === '0') {
          if (localStorage.getItem('emailBindCount') === '0') {
            this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(() => {
              this.$notify({
                title: '未绑定邮箱',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                message: "<a class='linkA' href='/userInfo/userCenter?toTableIndex=1'>您的账户尚未绑定邮箱,点击前往绑定</a>",
                position: 'bottom-right',
                duration: 0
              });
            });
            localStorage.setItem('emailBindCount', '1');
          }
        }

        if (localStorage.getItem('phoneBind') === '0') {
          if (localStorage.getItem('phoneBindCount') === '0') {
            this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(() => {
              this.$notify({
                title: '未绑定手机',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                message: "<a class='linkA' href='/userInfo/userCenter?toTableIndex=1'>您的账户尚未绑定手机,点击前往绑定</a>",
                position: 'bottom-right',
                duration: 0,
                onClose: function () {
                  localStorage.setItem('phoneBindCount', '0');
                }
              });
            });
            localStorage.setItem('phoneBindCount', '1');
          }
        }

        /*if (localStorage.getItem('infoCompleted') === '0') {
          if (localStorage.getItem('infoCompletedCount') === '0') {
            this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(() => {
              this.$notify({
                title: '未完善信息',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                message: "<a class='linkA' href='/userInfo/userCenter?toTableIndex=0'>您的个人信息尚未完善,点击前往完善</a>",
                position: 'bottom-right',
                duration: 0
              });
            });
            localStorage.setItem('infoCompletedCount', '1');
          }
        }*/

        /*if (localStorage.getItem('secretProtectionBind') === '0') {
          if (localStorage.getItem('secretProtectionBindCount') === '0') {
            this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(() => {
              this.$notify({
                title: '未完善密保信息',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                message: "<a class='linkA' href='/userInfo/userCenter'>您的密保信息尚未完善,点击前往完善</a>",
                position: 'bottom-right',
                duration: 0,
                onClose: function () {
                  localStorage.setItem('secretProtectionBindCount', '0');
                }
              });
            });
            localStorage.setItem('secretProtectionBindCount', '1');
          }
        }*/
      }
      window.onresize = () => {
        return (() => {
          this.screenHeight = window.innerHeight;
          document.getElementById('messageDiv').style.height = this.screenHeight - 90 + 'px';
        })()
      }
    },
    created() {
      this.isPhone = isPhone();
    },
    methods: {
      setMessageDivHeight(){
        this.screenHeight = window.innerHeight;
        document.getElementById('messageDiv').style.height = this.screenHeight - 90 + 'px';
      },
      handleHeaderDropDown(command) {
        if (command === 'login') {
          this.$router.push('/userLogin');
        }
        if (command === 'loginOut') {
          this.$confirm('确定退出当前登录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.1)'
            });
            loginOut().then((res) => {
              if (res.data.code === 200) {
                localStorage.clear();
                this.isLogined = false;
                this.$store.commit('userInfo/saveUserInfo', null);
                this.$notify({
                  title: '成功登出',
                  message: '即将刷新当前页面',
                  type: 'success'
                });
                setTimeout(function () {
                  loading.close();
                  window.location.reload();
                }, 3000);
                this.$ws.ws.close();
              }
            })
          }).catch(() => {

          });
        }
        if (command === 'myMessage') {
          this.messageDrawer = true;
        }
        if(command === 'myReport'){
          this.$router.push('/userInfo/myReport')
        }
      },

      allMessageIsRead() {
        this.checkedMessage = [];
        this.updateMessageIsRead();
      },
      allMessageDelete() {
        this.checkedMessage = [];
        this.deleteMessage();
      },
      getNewArr(list) {
        for (let i = list.length; i < 0; i--) {
          list[i + 1] = list[i];
        }
        return list;
      },
      updateMessageIsRead() {
        this.markedBtnActive = true;
        let that = this;
        updateMessageIsRead(that.checkedMessage).then((res) => {

          if (res.data.code == 200) {
            if (that.checkedMessage.length === 0) {
              that.messageInfo.messageInfoData.forEach((item, index) => {
                that.messageInfo.messageInfoData[index].isRead = 1;
              });
              that.markedBtnActive = false;
              that.hasNewMessage = false;
              that.newMessageCount = 0;
            } else {
              that.markedBtnActive = false;
              that.messageInfo.messageInfoData.forEach((item, index) => {
                that.checkedMessage.find(checkedItem => {
                  if (checkedItem === item.id) {
                    that.messageInfo.messageInfoData[index].isRead = 1;
                    that.messageInfo.messageInfoData[index].isChecked = false;
                  }
                })
              });
              let nowNewMessageCount = 0;
              nowNewMessageCount = that.newMessageCount - that.checkedMessage.length;
              if(nowNewMessageCount <= 0){
                that.newMessageCount = 0;
                that.hasNewMessage = false;
              }else{
                that.newMessageCount = nowNewMessageCount;
              }
              this.checkedMessage = [];
            }
            that.checkAllMessage = false;
            that.isIndeterminate = false;
          } else if (res.data.code == 300) {
            this.$notify({
              title: '操作失败',
              message: '执行操作失败[' + res.data.message + ']',
              type: 'warning'
            });
            this.markedBtnActive = false;
          } else {
            this.$notify({
              title: '系统错误',
              message: '系统内部运行出错[' + res.data.message + ']',
              type: 'error'
            });
            this.markedBtnActive = false;
          }
        });
      },
      deleteMessage() {
        this.markedBtnActive = true;
        let that = this;

        deleteMessage(that.checkedMessage).then((res) => {

          if (res.data.code == 200) {
            if (that.checkedMessage.length === 0) {
              that.messageInfo.messageInfoData = [];
              that.messageInfo.total = 0;
              that.messageInfo.currentPage = 1;
              that.markedBtnActive = false;
              that.hasNewMessage = false;
              that.newMessageCount = 0;
            } else {
              that.markedBtnActive = false;
              that.messageInfo.messageInfoData.forEach((item, index) => {
                that.checkedMessage.find(checkedItem => {
                  if (checkedItem === item.id) {
                    that.messageInfo.messageInfoData.splice(index, 1);
                  }
                })
              });
              let nowNewMessageCount = 0;
              nowNewMessageCount = that.newMessageCount - that.checkedMessage.length;
              if(nowNewMessageCount <= 0){
                that.newMessageCount = 0;
                that.hasNewMessage = false;
              }else{
                that.newMessageCount = nowNewMessageCount;
              }
              this.checkedMessage = [];
            }
            this.getNettyMessage({
              page: 1,
              pageSize: this.messageInfo.pageSize
            });
            that.checkAllMessage = false;
            that.isIndeterminate = false;
          } else if (res.data.code == 300) {
            this.$notify({
              title: '操作失败',
              message: '执行操作失败[' + res.data.message + ']',
              type: 'warning'
            });
            this.markedBtnActive = false;
          } else {
            this.$notify({
              title: '系统错误',
              message: '系统内部运行出错[' + res.data.message + ']',
              type: 'error'
            });
            this.markedBtnActive = false;
          }
        });
      },
      getNettyMessage(queryForm) {
        this.markedBtnActive = true;
        getNettyMessage(queryForm).then((res) => {
          if (res.data.code == 200) {
            this.messageInfo.total = res.data.data.page.totalElements;
            this.messageInfo.messageInfoData = res.data.data.page.content;
            this.newMessageCount = 0;
            this.hasNewMessage = false;
            /*if (this.messageInfo.messageInfoData && this.messageInfo.messageInfoData.length > 0) {
              this.messageInfo.messageInfoData.forEach(item => {
                if (item.isRead === 0) {
                  this.newMessageCount += 1;
                  this.hasNewMessage = true;
                }
              });
            }*/
            if(res.data.data.unreadSize > 0){
              this.newMessageCount = res.data.data.unreadSize;
              this.hasNewMessage = true;
            }
            this.markedBtnActive = false;
          } else if (res.data.code == 300) {
            this.markedBtnActive = false;
            this.$notify({
              title: '获取失败',
              message: '获取站内信息失败[' + res.data.message + ']',
              type: 'warning'
            });
          } else {
            this.markedBtnActive = false;
            this.$notify({
              title: '系统错误',
              message: '系统内部发生错误[' + res.data.message + ']',
              type: 'error'
            });
          }
        });
      },

      messageHandleCommand(command) {
        if (command === 'markedHadRead') {
          if (this.checkedMessage.length === 0) {
            this.$message.warning('至少选择一条记录！')
            return false;
          }
          this.updateMessageIsRead();
        }
        if (command === 'markedDelete') {
          if (this.checkedMessage.length === 0) {
            this.$message.warning('至少选择一条记录！')
            return false;
          }
          this.deleteMessage();
        }
      },

      handleCheckAllMessage(val) {
        if (val) {
          this.checkedMessage = [];
          this.messageInfo.messageInfoData.forEach((item, index) => {
            this.checkedMessage.push(item.id);
            this.messageInfo.messageInfoData[index].isChecked = true;
          });
        } else {
          this.checkedMessage = [];
          this.messageInfo.messageInfoData.forEach((item, index) => {
            this.messageInfo.messageInfoData[index].isChecked = false;
          });
        }
        this.isIndeterminate = false;
      },
      handleCheckedMessageChange(value) {
        let nowIndex = -1;
        if (this.checkedMessage.length > 0) {
          let isExists = this.checkedMessage.find((item, index) => {
            if (item === value.id) {
              nowIndex = index;
              return true;
            }
          });
          if (!isExists && value.isChecked) {
            this.checkedMessage.push(value.id);
          } else if (isExists && !value.isChecked) {
            this.checkedMessage.splice(nowIndex, 1);
          } else {
            this.checkedMessage.splice(nowIndex, 1);
          }
          if (this.checkedMessage.length === this.messageInfo.messageInfoData.length) {
            this.isIndeterminate = false;
            this.checkAllMessage = true;
          } else {
            if (this.checkedMessage.length === 0) {
              this.isIndeterminate = false;
              this.checkAllMessage = false;
            } else {
              this.isIndeterminate = true;
              this.checkAllMessage = false;
            }
          }
        } else {
          this.checkedMessage.push(value.id);
          this.isIndeterminate = true;
        }
      },
      handleMessagePageChange(nowPage) {
        this.messageInfo.currentPage = nowPage;
        this.getNettyMessage({
          page: this.messageInfo.currentPage,
          pageSize: this.messageInfo.pageSize
        });
      },
      handleMessageSizeChange(nowPageSize){
        this.messageInfo.pageSize = nowPageSize;
        this.getNettyMessage({
          page: this.messageInfo.currentPage,
          pageSize: this.messageInfo.pageSize
        });
      },
      showMessageDetail(obj) {
        this.messageVisible = true;
        this.messageDetail = {};
        this.messageDetail = obj;
        this.messageTitle = obj.messageTitle;
        if(obj.isRead === 0){
          this.checkedMessage = [];
          this.checkedMessage.push(obj.id);
          this.updateMessageIsRead();
        }
      },
      navgtTo: function (path) {
        this.$router.push(path);
      },

      goSearch: function () {
        let productType
        if(this.selectIndex === 4){
          productType = 'ORG'
        }else{
          productType = 'COMPANY'
        }
        woleSearch(this.fullSearch, productType);
      },
      openNewLink: function (url) {
        window.open(url);
      }
    }
  }
</script>
<style>
  .msglist-item {
    display: inline-block;
    margin-right: 10px;
  }

  .msglist-enter-active, .msglist-leave-active {
    transition: all 1s;
  }

  .msglist-enter, .msglist-leave-to
    /* .list-leave-active for below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(30px);
  }

  .msglist-move {
    transition: all 1s ease;
  }

  .msglist-leave-active {
    position: absolute;
  }

</style>

<style scoped>
  /*svg 图标 start*/
  .svg-icon-warp {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background: #fff;
    display: flex;
  }

  .svg-icon-warp svg {
    margin: auto;
  }

  /*end svg 图标*/
  .def-header {
    line-height: 112px;
  }

  .def-bg {
    width: 100%;
    min-width: 1100px;
    background-color: #00bca1;
  }

  .h-warp {
    height: 112px;
    line-height: 112px;
    display: flex;
    flex-flow: row nowrap;
    color: #fff;
    text-align: center;
  }

  /*logo start*/
  .h-warp .h-icon {
    width: 138px;
    padding-left: 24px;
  }

  .h-warp .fz {
    cursor: pointer;
    color: #fff;
    font-size: 28px;
  }

  /*end logo*/
  /*菜单 start*/
  .h-warp .h-menu {
    width: 791px;
    display: flex;
    flex-flow: row;
    justify-content: space-around;
  }

  .h-warp .m-item {
    position: relative;
    flex: auto;
    cursor: pointer;
    font-size: 20px;
    padding: 0 10px;
  }

  .h-warp .m-item.active {
    font-weight: 600;
  }

  /*end 菜单*/
  /*header 右边 start*/
  .h-warp .h-right {
    width: 559px;
    display: flex;
  }

  .h-warp .h-right .hr-left {
    padding-left: 70px;
    width: 300px;
  }

  .h-warp .h-right .hr-right {
    width: 134px;
    display: flex;
    align-items: center;
  }

  .hot-item {
    position: absolute;
    top: -8px;
    left: 75%;
  }
  /*end header 右边*/

  .badge-item {
    position: absolute;
    top: -43px;
    left: 35px;
  }

  .login-icon {
    font-size: 20px;
    cursor: pointer;
    fill: #00BCA1;
  }

  .userCenter-icon {
    font-size: 25px;
    cursor: pointer;
    fill: #00BCA1;
  }

  .login-drop-icon {
    right: 5px;
  }

  .messageDiv {
    position: relative;
    /* left: 80px; */
    width: 80%;
    margin: auto;
    height: 100%;
    overflow: auto;
  }
  .messageDiv::-webkit-scrollbar { /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    position: absolute;
    left: 10px;
    height: 1px;
  }

  .messageDiv::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }

  .messageDiv::-webkit-scrollbar-track { /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #EDEDED;
  }

  .messageDiv ul {
    width: 90%;
    /* height: 100%; */
    padding: 20px 0px 0px 0px;
  }

  .messageDiv ul li {
    position: relative;
    list-style: none;
    width: 100%;
    height: 100px;
    margin-top: 10px;
    margin-left: 30px;
    display: inline-block;
  }

  /*.messageDiv ul li:before, .messageDiv ul li:after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border: 2px solid transparent;
    box-sizing: border-box;
    position: absolute;
  }

  .messageDiv ul li:before {
    bottom: 0;
    left: 0;
    transition: border-color 0s ease-in 0.8s, width 0.2s ease-in 0.6s, height 0.2s ease-in 0.4s;
  }

  .messageDiv ul li:after {
    bottom: 0;
    left: 0;
    transition: border-color 0s ease-in 0.4s, width 0.2s ease-in 0.2s, height 0.2s ease-in;
  }

  .messageDiv ul li:hover:before {
    width: 100%;
    height: 100%;
    transition: width 0.2s ease-in, height 0.2s ease-in 0.2s;
    border-right-color: #00BCA1;
    border-bottom-color: #00BCA1;
  }

  .messageDiv ul li:hover:after {
    width: 100%;
    height: 100%;
    transition: border-color 0s ease-in 0.4s, width 0.2s ease-in 0.4s, height 0.3s ease-in 0.6s;
    border-right-color: #00BCA1;
    border-bottom-color: #00BCA1;
  }*/
  .readTipIcon {
    position: absolute;
    top: 0px;
    left: 0px;
  }

  .isNotRead {
    color: rgb(234, 98, 98);
    font-size: 35px;
  }

  .isRead {
    font-size: 35px;
  }

  .messageDateDiv {
    font-size: 10px;
    position: absolute;
    right: 30px;
    top: 4px;
    color: rgba(127, 130, 147, 0.47)
  }

  .messageContentDiv {
    font-size: 18px;
    position: absolute;
    left: 15px;
    top: 50px;
    color: rgb(127, 130, 147);
    width: 80%;
    /* height: 30px; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .titleShowDetail {
    font-size: 12px;
    color: #7F8293;
    cursor: pointer;
  }

  .titleShowDetail:hover {
    color: #00BCA1;
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue